import React, { Component } from "react";
import ReactOwlCarousel from 'react-owl-carousel';
import NewsCard from "./NewsCard";
import News from "./data/News";


class OurNews extends Component {
  
    constructor(props) {
        super(props)

        this.state = {
            options: {
                loop: true,
                margin: 10,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true,
                        dots: false
                    },
                    600: {
                        items: 2,
                        nav: true,
                        dots: false
                    },
                    1000: {
                        items: 3,
                        nav: true,
                        dots: false
                    }
                }
            }
        }
    }

    render() {
        return (
            <section className="section cm-blogs" id="news">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h2 className="section-heading h1 text-dark mb-15">Le nostre notizie</h2>
                        </div>
                        <div className="carousel-fluid" id="news" key="news-carousel-container">
                            <div className="row no-gutters justify-content-center">
                                <div className="col-md-12 col-lg-36">
                                    <ReactOwlCarousel center loop nav margin={30} items={2} key={Math.random().toString(36).substring(7)} id="news-carousel" className='owl-theme' {...this.state.options}>
                                        {
                                            News.map(newsItem => <NewsCard newsItem={newsItem}></NewsCard>)
                                        }
                                    </ReactOwlCarousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        );
    }
}

export default OurNews;
